import React, { Component } from "react";
import { Link } from "react-router-dom";

import ReactUUID from "react-uuid";

export default class UBXTreeItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: "",
        };
    }

    async componentDidMount() {
        const { id = ReactUUID() } = this.props;

        await this.setState({ id });
    }

    itemClick(e) {
        const { onClick = false } = this.props;

        if (onClick) {
            return onClick(e);
        }

        return true;
    }

    renderItem() {
        const { label: title, status, link = false, active = false, action = false } = this.props;

        const customClasses = [];
        const customAttrs = { title };
        if (link) {
            customClasses.push("tree-item-link");
            customAttrs["to"] = link;
        } else {
            customClasses.push("tree-item-text");
        }

        if (status) {
            customClasses.push(status);

            if (status === "resubmit") {
                customAttrs["action"] = action;

                if (action >= 10) {
                    customClasses.push("xs");
                }
            }
        }

        if (active) {
            customClasses.push("active");
        }

        return link ? (
            <Link className={customClasses.join(" ")} {...customAttrs} onClick={(e) => this.itemClick(e)}>
                {title}
            </Link>
        ) : (
            <span className={customClasses.join(" ")} onClick={(e) => this.itemClick(e)} {...customAttrs}>
                {title}
            </span>
        );
    }

    render() {
        const { type } = this.props;
        const { id } = this.state;

        let customClass = [];
        if (type) {
            customClass.push(type);
        }

        const customAttrs = { id };

        return (
            <span className={`ubx-commons tree-item ${customClass}`} {...customAttrs}>
                {this.renderItem()}
            </span>
        );
    }
}
